var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items.length > 0
    ? _c(
        "table",
        { staticClass: "table table-responsive-xl table-bordered footable" },
        [
          _c("tbody", [
            _c(
              "tr",
              [
                _c("td", { attrs: { width: "70" } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(this.cur_item.name) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "td",
                    {
                      class: _vm.get_item_class(item),
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.on_change(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.time) +
                          "\n            "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }